import React, { Component } from "react";
import { Table, Row, Col, Button, Modal, Container, Form, Image, ModalBody, ModalFooter } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./EditSupport.css";

var dateFormat = require("dateformat");

class EditSupport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        asgndTo: "Select Support Users",
        priority: "",
        remarks: "",
        id: this.props.ItemList ? this.props.ItemList.id : null,
        status: this.props.ItemList ? this.props.ItemList.status : null,
      },
      historypage:0,
      historyperpage:5
    };
  }

  resetitemPage = () => {
    //For resetting the history table to page 1 in pagination
    this.setState({
      ...this.state,
      historypage: 0
    });
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        ...this.state.value,
        sprtId: this.props.ItemList.id,
        status: this.props.ItemList.status
      }
    });
  }

  handleHistoryPageClick = e => {
    const selectedHistoryPage = e.selected;
    this.props.SupportHistorySelectedPage({
      sprtId: this.props.ItemList.id,
      page: selectedHistoryPage + 1
    });
    this.setState({
      historypage: selectedHistoryPage,
    });
  };

  selectSupportUsers = e => {
    this.setState({ value: { ...this.state.value, asgndTo: e.target.value } });
  };

  onChangePriority = event => {
    this.setState({ value: { ...this.state.value, priority: event.target.value } });
  };

  onChangeStatus = event => {
    this.setState({ value: { ...this.state.value, status: event.target.value } });
  };

  onChangehandler = e => {
    const name = e.target.name;
    const value = e.target.value;
    if (name == "remarks") {
      this.setState({ value: { ...this.state.value, remarks: value } });
    }
  };

  addSupportHistory=()=> {

    if (
      this.state.value.priority !== "Select Priority" &&
      this.state.value.asgndTo !== "Select Support Users" &&
      this.state.value.remarks !== "" && this.state.value.status !== "Select Status"
    ) {
      this.props.addSupportHistory(this.state.value);
      this.props.editSupport(this.state.value);

      this.setState({
        value: {
          priority: "Select Priority",
          asgndTo: "Select Support Users",
          remarks: "",
          status: "Select Status"
        },
      },()=>{this.props.closeEditModel();});
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  closeModal=()=> {
    this.setState({
      value: {
        priority: "Select Priority",
        asgndTo: "No Support Users",
        remarks: "",
        status: "Select Status"
      }
    },()=>{this.props.closeEditModel();});
  }

  render() {
    let s = this.state.historypage + 1;
    const count =this.props.supportHistoryCount && this.props.supportHistoryCount;
    let SupportPageCount = Math.ceil(count / this.state.historyperpage);

    return (
      <Modal
        show={this.props.showEditModel}
        onHide={this.closeModal}
        animation={false}
        size="lg"
        backdrop="static"
      >
        {this.props.ItemList&&this.props.ItemList.status==="closed"?
        (<Modal.Header
          style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
          closeButton
        >
          <span style={{ fontSize: "20px" }}>Ticket closed </span>
        </Modal.Header>)
        :
        <Modal.Header
          style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
          closeButton
        >
          <span style={{ fontSize: "20px" }}>Assign Support </span>
        </Modal.Header>}
        {this.props.ItemList&&this.props.ItemList.status==="closed"?
        (<Modal.Body style={{textAlign:"center"}}>
          Support ticket has been closed by the support user
        </Modal.Body>)
        :
        (<Modal.Body>
          <Container>
            <Form>
              <Row>
                <Col lg={6} md={12} sm={12} xs={12}>
                  <Container>
                    <Row>
                      <Form.Group
                        controlId="asgndTo"
                        style={{ width: "100%" }}
                      >
                        <Form.Label className="mandatoryField">Support User</Form.Label>
                        <div style={{ width: "100%" }}>
                          <select style={{ width: "100%" }}
                            onChange={this.selectSupportUsers}
                            class="form-control"
                            className="supportSelect"
                          >
                            <option>Select Support User</option>
                            {this.props.supportUsersList &&
                              this.props.supportUsersList.map((item, i) => (
                                <option key={i} value={item.id}>
                                  {item.fName}  {item.lName}
                                </option>
                              ))}
                          </select>
                        </div>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group
                        controlId="priority"
                        style={{ width: "100%" }}
                      >
                        <Form.Label className="mandatoryField">Priority</Form.Label>
                        <div style={{ width: "100%" }}>
                          <select style={{ width: "100%" }}
                            onChange={this.onChangePriority}
                            className="supportSelect"
                            id="priority"
                            value={this.state.value.priority}
                          >
                            <option value="select" defaultValue>
                              Select Priority
                      </option>
                            <option value="low">Low</option>
                            <option value="medium">Medium</option>
                            <option value="high">High</option>
                            <option value="urgent">Urgent</option>
                          </select>
                        </div>
                      </Form.Group>
                    </Row>
                  </Container>
                </Col>

                <Col lg={6} md={12} sm={12} xs={12}>
                  <Container>
                    <Row>
                      <Form.Group
                        controlId="status"
                        style={{ width: "100%" }}
                      >
                        <Form.Label className="mandatoryField">Support Status</Form.Label>
                        <div style={{ width: "100%" }}>
                          <select style={{ width: "100%" }}
                            onChange={this.onChangeStatus}
                            className="supportSelect"
                            id="status"
                            value={this.state.value.status}
                          >
                            <option value="select" defaultValue>
                              Select status
                      </option>
                            <option value="created">Created</option>
                            <option value="in progress">In Progress</option>
                            <option value="closed">Closed</option>
                          </select>
                        </div>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group controlId="remarks" style={{ width: "100%" }}>
                        <Form.Label className="mandatoryField">Remarks</Form.Label>
                        <div>
                          <Form.Control style={{ width: "100%" }}
                            as="textarea"
                            name="remarks"
                            autoComplete="off"
                            onChange={this.onChangehandler}
                            value={this.state.value.remarks}
                          />
                        </div>
                      </Form.Group>
                    </Row>
                  </Container>
                </Col>
              </Row>
            </Form>
          </Container>
        </Modal.Body>)}
        {this.props.ItemList&&this.props.ItemList.status==="closed"?
        ""
        :
        (<Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
          <Button type="submit" onClick={this.addSupportHistory}>
            Submit
          </Button>
        </Modal.Footer>)}
        <hr></hr>
          <Modal.Header
            style={{ fontSize: "10px", backgroundColor: "#f0f3f5" }}
          >
            <span style={{ fontSize: "20px" }}>Support History Details</span>

            <Col xs={12} sm={12} md={3} lg={3}>
              <div className="commonRecrd">
                <i className="cui-note icons cmnRecordIcon"></i>
                <span className="cmnPageCount">{count?count:0}</span>
                <span style={{ fontSize: "15px", fontWeight: "400" }}>Results</span>
              </div>
            </Col>
          </Modal.Header>
          <Modal.Body>
        <Container>
          <Table responsive bordered striped className="cmnMainTable">
              <thead>
                <tr className="cmnMainTableHd">
                  <th style={{ width: "50px" }}>SL NO</th>
                  <th style={{ width: "150px" }}>ASSIGNED TO</th>
                  <th style={{ width: "150px" }}>PRIORITY</th>
                  {/* <th>SUPPORT STATUS</th> */}
                  <th style={{ width: "180px" }}>UPDATED DATE & TIME</th>
                  <th style={{ width: "150px" }}>REMARKS</th>
                </tr>
              </thead>
              <tbody>
                {this.props.supportHistoryList &&
                  this.props.supportHistoryList.map((item, i) => (
                    <tr key={i}>
                      <td className="cmn_Cap">{5 * (s - 1) + i + 1}</td>
                      <td className="cmn_Cap">{item.asgndTo.fName !== null &&
                        item.asgndTo.fName} {item.asgndTo.lName !== null && item.asgndTo.lName}</td>
                      <td className="cmn_Cap">{item.priority !== null && item.priority}</td>
                      {/* <td className="cmn_Cap">{item.sprtId.status !== null && item.sprtId.status}</td> */}
                      <td className="cmn_Cap">{item.createdAt !== null &&
                        dateFormat(item.createdAt, "mediumDate")} {dateFormat(item.createdAt, "mediumTime")}</td>
                      <td className="cmn_Cap">{item.remarks !== null && item.remarks}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>

          {((this.props.supportHistoryList === undefined) ||
            (this.props.supportHistoryList &&
              this.props.supportHistoryList.length === 0)) && (
              <div>
                <div className="noDataImgDiv">
                  <Image
                    className="noDataImg"
                    src={require("../../assets/img/nodata4.png")}
                  />
                </div>
                <div className="noDataTextDiv">No Histories Found</div>
              </div>
            )}
</Container>
</Modal.Body>
          {SupportPageCount > 1 ? (
              <div className="paginationDiv">
                <ReactPaginate
                  forcePage={this.state.historypage}
                  previousLabel={"Prev"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={SupportPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handleHistoryPageClick}
                  containerClassName={"pagination flex-wrap"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            ) : null}
      </Modal>
    );
  }
}

export default EditSupport;
